import { z } from "zod";

import { ScreenshotRecommendationHistoryDtoSchema } from "../../../dtos/ai";

export const AiGetScreenshotRecommendationsHistoryRequestBodySchema = z.object({
  url: z.string(),
  shopId: z.string(),
});

export type AiGetScreenshotRecommendationsHistoryRequestBodyType = z.infer<
  typeof AiGetScreenshotRecommendationsHistoryRequestBodySchema
>;

export const AiGetScreenshotRecommendationsHistoryResponseSchema = z.object({
  recommendations: ScreenshotRecommendationHistoryDtoSchema.array(),
});

export type AiGetScreenshotRecommendationsHistoryResponseBodyType = z.infer<
  typeof AiGetScreenshotRecommendationsHistoryResponseSchema
>;
